
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/solution-list",
      function () {
        return require("private-next-pages/solution-list/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/solution-list"])
      });
    }
  